import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as R from 'ramda'

import { connectApi } from 'libs/connectApi'
import { toastr } from 'libs/toast'
import { getSurveyFromId, updateSurveyFromId } from 'actions'
import { isSurveyActive } from 'libs/survey'
import { SurveySettingsV2 } from 'organisms/SurveySettingsV2'
import auth from 'auth'

class SurveySettings extends React.Component {
  static propTypes = {
    getSurveyFromId: PropTypes.func,
    match: PropTypes.object,
    surveyName: PropTypes.string,
    surveyStatus: PropTypes.string,
    updateSurveyFromId: PropTypes.func,
    history: PropTypes.object,
    surveyToken: PropTypes.string,
  }

  state = {
    surveyName: this.props.surveyName || 'Zendesk Ticket Satisfaction',
    surveyStatus: this.props.surveyStatus,
    confirmationModalOpen: false,
  }

  componentDidMount = async () => {
    const surveyId = getSurveyIdFromURL(this.props.match)
    const { push } = this.props.history
    const data = await this.props.getSurveyFromId(surveyId)
    if (data.status === 404) {
      push('/404')
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.surveyName !== this.props.surveyName) {
      this.setState({
        surveyName: this.props.surveyName,
      })
    }
    if (prevProps.surveyStatus !== this.props.surveyStatus) {
      this.setState({
        surveyStatus: this.props.surveyStatus,
      })
    }
  }

  onChangeSurveyName = (event) => {
    this.setState({
      surveyName: event.target.value,
    })
  }

  updateSurvey = (event) => {
    event.preventDefault()

    const surveyId = getSurveyIdFromURL(this.props.match)
    this.props
      .updateSurveyFromId(surveyId, {
        name: this.state.surveyName,
      })
      .then(() => {
        toastr.success('Survey settings were successfully updated.')
      })
      .catch(() => {
        toastr.error('Failed to update. Please try again.')
      })
  }

  updateAndContinue = (event) => {
    this.updateSurvey(event)

    const surveyId = getSurveyIdFromURL(this.props.match)
    this.props.history.push(`/settings/surveys/${surveyId}/landing-page`)
  }

  updateSurveyStatus = (event) => {
    event.preventDefault()

    const surveyId = getSurveyIdFromURL(this.props.match)
    this.setState(
      (prevState) => ({
        surveyStatus: isSurveyActive(prevState.surveyStatus, 'archived', 'active'),
      }),
      () => this.props.updateSurveyFromId(surveyId, { status: this.state.surveyStatus })
    )
    this.toggleConfirmationModal()
  }

  toggleConfirmationModal = () =>
    this.setState((prevState) => ({ confirmationModalOpen: !prevState.confirmationModalOpen }))

  render() {
    if (this.props.surveyToken && this.props.featureToggle.data) {
      const surveyId = getSurveyIdFromURL(this.props.match)
      const companyId = auth.getUserInfoFromToken().company.id
      const isEnableConditionalLogicFeatureToggle = R.path(
        ['enable_conditional_logic'],
        this.props.featureToggle.data
      )

      return (
        <SurveySettingsV2
          surveyToken={this.props.surveyToken}
          surveyId={surveyId}
          companyId={companyId}
          isEnableConditionalLogicFeatureToggle={isEnableConditionalLogicFeatureToggle}
        />
      )
    }

    return null
  }
}

const getSurveyIdFromURL = (matchProps) => {
  const {
    params: { surveyId },
  } = matchProps
  return surveyId
}

const mapState = (state, props) => {
  const surveyId = getSurveyIdFromURL(props.match)
  return {
    surveyName: R.path(['data', 'surveys', 'entity', surveyId, 'name'], state),
    surveyType: R.path(['data', 'surveys', 'entity', surveyId, 'type'], state),
    surveyStatus: R.path(['data', 'surveys', 'entity', surveyId, 'status'], state),
    surveyToken: R.path(['data', 'surveys', 'entity', surveyId, 'token'], state),
  }
}

const mapDispatch = (dispatch) => ({
  getSurveyFromId: (surveyId) => dispatch(getSurveyFromId(surveyId)),
  updateSurveyFromId: (surveyId, settings) => dispatch(updateSurveyFromId(surveyId, settings)),
})

export default R.compose(
  connectApi({
    name: 'featureToggle',
    url: 'dashboard/feature-toggle/',
  }),
  withRouter,
  connect(mapState, mapDispatch)
)(SurveySettings)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Surveys/SurveySettings.js